import React, {
  useMemo, lazy, Suspense, memo,
} from 'react';
import PropTypes from 'prop-types';
import {
  Box, CircularProgress, FormControlLabel, ListItem, Switch,
} from '@mui/material';
// eslint-disable-next-line import/no-cycle
import { foreignPropType } from '../../../itemField';

function FilerField({
  desc, value, onSetFilter,
}) {
  const onChange = useMemo(
    () => (e, v) => onSetFilter(desc.name, v, true),
    [desc.name, onSetFilter],
  );

  const FilterComponent = useMemo(() => {
    if (desc.type === 'string') {
      return lazy(() => import('../../../BaseEditor/stringInput'));
    }
    if (desc.type === 'date') {
      return lazy(() => import('../../../BaseEditor/dates/dateInput'));
    }
    if (desc.type === 'boolean') {
      return lazy(() => import('../../../BaseEditor/selector'));
    }
    if (desc.type === 'integer') {
      return lazy(() => import('../../../BaseEditor/numberInput'));
    }
    if (desc.type === 'nested object' && desc.resource) {
      // eslint-disable-next-line import/no-cycle
      return lazy(() => import('../../../itemField/itemPicker'));
    }
    if (desc.type === 'choice') {
      // eslint-disable-next-line import/no-cycle
      return lazy(() => import('../../../BaseEditor/selector'));
    }
    return null;
  }, [desc]);

  const fcProps = useMemo(
    () => {
      const globalProps = {
        id: `filter-${desc.name}-changer`,
        value: value ? value.value : null,
        onChange,
      };
      if (desc.type === 'string') {
        return {
          ...globalProps,
          onChange: (e, v) => onSetFilter(desc.name, v, !!v.length),
        };
      }
      if (desc.type === 'boolean') {
        return {
          ...globalProps,
          values: [
            { value: true, display_name: 'Так' },
            { value: false, display_name: 'Ні' },
          ],
        };
      }
      if (desc.type === 'integer') {
        return {
          ...globalProps,
          minValue: desc.min_value,
          maxValue: desc.max_value,
        };
      }
      if (desc.type === 'nested object' && desc.resource) {
        return {
          ...globalProps,
          backend: desc.resource,
          // maxValue: desc.max_value,
          // onChange: (e, v) => onSetFilter(desc.name, v && v.id, !!v),
          canErase: true,
        };
      }
      if (desc.type === 'choice') {
        return {
          ...globalProps,
          values: desc.choices,
        };
      }
      return globalProps;
    },
    // eslint-disable-next-line max-len
    [desc.choices, desc.max_value, desc.min_value, desc.name, desc.resource, desc.type, onChange, onSetFilter, value],
  );
  return (
    <ListItem divider>
      <Box width={1} display="flex">
        {FilterComponent ? (
          <>
            <FormControlLabel
              control={(
                <Switch
                 // id={`filter-${desc.name}-check`}
                  onChange={() => (value ? onSetFilter(desc.name, value.value, !value.use) : null)}
                  checked={value && value.use}
                />
             )}
              label={desc.label}
            />
            <Suspense fallback={<CircularProgress />}>
              <FilterComponent {...fcProps} />
            </Suspense>
          </>
        )
          : process.env.NODE_ENV === 'development' && (
          <Box sx={{ bgcolor: 'error.main', color: 'white' }}>
            {`Type ${desc.type} not supported in filter ${desc.name}`}
          </Box>
          )}
      </Box>
    </ListItem>
  );
}

FilerField.propTypes = {
  desc: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    resource: PropTypes.string,
    min_value: PropTypes.number,
    max_value: PropTypes.number,
    choices: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string, PropTypes.number, PropTypes.bool,
      ]),
      display_name: PropTypes.string,
    })),
  }).isRequired,
  value: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string, // str & date
      PropTypes.number, // int && decimal
      PropTypes.bool, //
      foreignPropType,
    ]),
    use: PropTypes.bool,
  }),
  onSetFilter: PropTypes.func.isRequired,
};

FilerField.defaultProps = {
  value: null,
};

export default memo(FilerField);
